// extracted by css-extract-rspack-plugin
export default {"cls1":"IconCell-cls1_gDj","cls2":"IconCell-cls2_3A1 IconCell-cls1_gDj"};